import styled from "@emotion/styled";
import { Box } from "@mui/material";

export const ExitButton = styled(Box)`
    @media (min-width: 1000px) {
        & {
            display: none;
        }
    }
`;
export const StyledOption = styled.li`
    position: relative;
    max-width: calc(100% - 10px);
    border-radius: 5px;
    opacity: 1 !important;
    font-family: "Nunito", sans-serif !important;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .in-use-label {
        color: #ed6c02;
        font-size: 14px;
        font-weight: 600;
        font-family: "Nunito", sans-serif;
        width: fit-content;
        margin-left: auto;
    }
`;
